module.exports = __webpack_public_path__ + "img/josh-riemer-flRN6KYpl1A-unsplash.2a012cb9.jpg";